import { cn } from './cn';

/**
 * Tecla de atajo.
 *
 * Los atajos se muestran siempre junto a la accion que ejecutan. Un atajo
 * que solo vive en la documentacion no lo usa nadie, y en una herramienta
 * operativa el teclado es lo que separa cinco segundos por recepcion de
 * cuarenta.
 */
export function Kbd({ children, className }: { children: string; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-4 min-w-4 items-center justify-center rounded-xs',
        'border border-line-strong bg-panel px-1',
        'font-mono text-2xs font-medium leading-none text-fg-subtle',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
